import React, { Component } from 'react'
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";



import "./CalibrationHelper.css"

class CalibrationHelper extends Component {
  state = {
    cameraDistance: 0,
    hotspotScale: 0,
  };


  render() {
    return (
      <Subscribe to={[StateContainer]}>
        {(state2) => (
          <div className="calibration-container">

            <div className="input-container">
              <label htmlFor="camera-distance">Camera distance :</label>
              <input
                id="camera-distance"
                defaultValue={state2.state.cameraDistanceMultiplier}
                step={0.00001}
                onChange={async (e) => {
                  await this.setState({ cameraDistance: e.target.value });
                  state2.updateSceneSettings(
                    this.state.cameraDistance,
                    this.state.hotspotScale
                  )

                }}
                type="number"
              />

            </div>
            <div className="input-container">
              <label htmlFor="hotspot-scale">Hotspot scale :</label>
              <input
                id="hotspot-scale"
                defaultValue={state2.state.hotspotScale}
                step={0.00001}
                onChange={async (e) => {
                  await this.setState({ hotspotScale: e.target.value });
                  state2.updateSceneSettings(
                    this.state.cameraDistance,
                    this.state.hotspotScale
                  )
                }}
                type="number"
              />

            </div>
          </div>
        )}
      </Subscribe>
    );
  }
}

export default CalibrationHelper;